
const backend_domain = 'https://admin.kanthasri.com/admin/api/v1';
const APIPATH = { 
    loginUser :{
        url : `${backend_domain}/user/login`,
        method : 'post'
    },
    logoutUser :{
        url : `${backend_domain}/user/logout`,
        method : 'post'
    },
    gettestdata :{
        url : `${backend_domain}/test/test-data`,
        method : 'get'
    },
    getSellers :{
        url : `${backend_domain}/product/utility/sellers`,
        method : 'get'
    },
    getSeller :{
        url : `${backend_domain}/seller/get`,
        method : 'get'
    },
    getInventories :{
        url : `${backend_domain}/product/utility/inventories`,
        method : 'get'
    },
    getCategories :{
        url : `${backend_domain}/product/utility/categories`,
        method : 'get'
    },
    getSubCategories :{
        url : `${backend_domain}/product/utility/subcategories`,
        method : 'get'
    },
    getChildCategories :{
        url : `${backend_domain}/common/utility/childCategories`,
        method : 'post'
    },
    getParentCategories :{
        url : `${backend_domain}/common/utility/parentCategories`,
        method : 'get'
    }, 
    getMainCategories :{
        url : `${backend_domain}/common/utility/mainCategories`,
        method : 'post'
    }, 
    getCourierNames :{
        url : `${backend_domain}/common/utility/couriernames`,
        method : 'get'
    }, 
    
    getGender :{
        url : `${backend_domain}/product/utility/gender`,
        method : 'get'
    },
    getColors :{
        url : `${backend_domain}/product/utility/colors`,
        method : 'get'
    },
    getSizes :{
        url : `${backend_domain}/product/utility/sizes`,
        method : 'get'
    },
    getFabrics :{
        url : `${backend_domain}/product/utility/fabrics`,
        method : 'get'
    },
    getMaterials :{
        url : `${backend_domain}/product/utility/matirials`,
        method : 'get'
    },
    getNeckStyleNames :{
        url : `${backend_domain}/product/utility/neckstylenames`,
        method : 'get'
    },
    getOccasions :{
        url : `${backend_domain}/product/utility/occasions`,
        method : 'get'
    },
    getOrnamentation :{
        url : `${backend_domain}/product/utility/ornamentation`,
        method : 'get'
    },
    getPatterns :{
        url : `${backend_domain}/product/utility/patterns`,
        method : 'get'
    },
    getSleeves :{
        url : `${backend_domain}/product/utility/sleeves`,
        method : 'get'
    },
    getClosureTypes :{
        url : `${backend_domain}/product/utility/closuretypes`,
        method : 'get'
    },
    getBackTypeNames :{
        url : `${backend_domain}/product/utility/backtypenames`,
        method : 'get'
    },
    getVariationType :{
        url : `${backend_domain}/product/utility/variationtypes`,
        method : 'get'
    },
    createProduct :{
        url : `${backend_domain}/product/create`,
        method : 'post'
    },
    getProducts :{
        url : `${backend_domain}/product/getproducts`,
        method : 'post'
    },
    getProductDetailsByBarcode :{
        url : `${backend_domain}/product/getproductbybarcode`,
        method : 'post'
    },
    getProductDetails :{
        url : `${backend_domain}/product/getproductdetails`,
        method : 'post'
    },
    updateProduct :{
        url : `${backend_domain}/product/updateproduct`,
        method : 'post'
    },
    createCoupon :{
        url : `${backend_domain}/coupon/create`,
        method : 'post'
    },
    updateCoupon :{
        url : `${backend_domain}/coupon/update`,
        method : 'post'
    },
    getCoupons :{
        url : `${backend_domain}/coupon/get`,
        method : 'get'
    },
    getUserCoupons :{
        url : `${backend_domain}/coupon/getusercoupons`,
        method : 'get'
    },
    assignUserCoupon :{
        url : `${backend_domain}/coupon/assignusercoupon`,
        method : 'post'
    },
    getInventories :{
        url : `${backend_domain}/inventory/getinventories`,
        method : 'get'
    },
    createInventory :{
        url : `${backend_domain}/inventory/createinventorydetail`,
        method : 'post'
    },
    updateInventory :{
        url : `${backend_domain}/inventory/updateinventorydetail`,
        method : 'post'
    },
    getStates :{
        url : `${backend_domain}/common/utility/states`,
        method : 'get'
    },
    getCountries :{
        url : `${backend_domain}/common/utility/countries`,
        method : 'get'
    },
     getRetailPaymentMethods :{
        url : `${backend_domain}/common/utility/retailpaymentmethods`,
        method : 'get'
    },
    getOrders :{
        url : `${backend_domain}/order/getorders`,
        method : 'post'
    },
    getOfflineCustomerDetails :{
        url : `${backend_domain}/order/offlinecustomerdetails`,
        method : 'post'
    },
    createOfflineOrder :{
        url : `${backend_domain}/order/createofflineorder`,
        method : 'post'
    },
    getOrderDetail :{
        url : `${backend_domain}/order/orderdetail`,
        method : 'post'
    },
    updateShippingDetails :{
        url : `${backend_domain}/order/updateshippingdetails`,
        method : 'post'
    },
    getShippingStatuses :{
        url : `${backend_domain}/common/utility/shippingstatuses`,
        method : 'get'
    },
    acceptOrderItem :{
        url : `${backend_domain}/order/acceptorderitem`,
        method : 'post'
    },
    getCancellationReasons :{
        url : `${backend_domain}/common/utility/cancellationreasons`,
        method : 'get'
    },
    createCancellation :{
        url : `${backend_domain}/order/cancellation/create`,
        method : 'post'
    },
    getManufacturerNames :{
        url : `${backend_domain}/common/utility/manufacturernames`,
        method : 'get'
    },
    createPurchaseOrder :{
        url : `${backend_domain}/purchase/create`,
        method : 'post'
    },
    getPurchaseOrderByRef :{
        url : `${backend_domain}/purchase/get`,
        method : 'post'
    },
    getPurchaseOrderByManufactutrerId :{
        url : `${backend_domain}/purchase/getRefNo`,
        method : 'post'
    },
    saveBlog :{
        url : `${backend_domain}/blog/save`,
        method : 'post'
    },
    getBlogs :{
        url : `${backend_domain}/blog/get`,
        method : 'get'
    },
    getArtists :{
        url : `${backend_domain}/artist/get-all`,
        method : 'get'
    },
    createArtist :{
        url : `${backend_domain}/artist/create`,
        method : 'post'
    },
    updateArtist :{
        url : `${backend_domain}/artist/update`,
        method : 'post'
    },
    getUserCount :{
        url : `${backend_domain}/user/getusercount`,
        method : 'get'
    },
    searchUsers :{
        url : `${backend_domain}/user/searchusers`,
        method : 'post'
    },
    getCarts :{
        url : `${backend_domain}/cart/getcarts`,
        method : 'post'
    },
    getCartItems :{
        url : `${backend_domain}/cart/getcartitems`,
        method : 'post'
    },

}
export default APIPATH